<template>
  <div class="detailPage">
    <div class="customer_wrap">
      <div class="customer_list">
        <div class="item">
          <div class="txt flex-rowl">
            <p class="label">客户名称：</p>
            <p>
              {{
                customerDetail.info_truename
                  ? customerDetail.info_truename
                  : customerDetail.ext_name
              }}
            </p>
          </div>
          <div class="txt flex-rowl">
            <p class="label">企业名称：</p>
            <p>{{ customerDetail.other_companystr }}</p>
          </div>
          <div class="txt flex-rowl">
            <p class="label">职务：</p>
            <p>{{ customerDetail.other_job }}</p>
          </div>
          <div class="txt flex-between">
            <div class="flex-rowl">
              <p class="label">联系方式：</p>
              <p>{{ customerDetail.info_mobile }}</p>
            </div>
            <div class="icon_wrap flex-rowr">
              <a :href="`tel:${customerDetail.info_mobile}`"
                ><i class="iconfont icon-dianhua"></i
              ></a>

              <i
                class="iconfont icon-fuzhi copy_box"
                :data-clipboard-text="customerDetail.info_mobile"
                @click="handleCopyBtn()"
              ></i>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="txt flex-rowl">
            <p class="label">客户标签：</p>
            <p>
              {{
                customerDetail.info_tag_idstr
                  ? customerDetail.info_tag_idstr
                  : ""
              }}
            </p>
            <!-- <div class="label_list flex-rowl">
              <div class="label_item">
                {{customerDetail.info_tag_idstr}} <i class="iconfont icon-checkbox-checked-o"></i>
              </div>
            </div> -->
          </div>
        </div>
        <div class="item red">
          <div class="txt flex-rowl">
            <p class="label">补充分类：</p>
            <p>{{ customerDetail.other_typestr }}</p>
          </div>
          <div class="txt flex-rowl">
            <p class="label">客户属性：</p>
            <p>{{ customerDetail.other_attrstr }}</p>
          </div>
          <div class="txt flex-rowl">
            <p class="label">联系优先度：</p>
            <p>{{ customerDetail.other_yxdstr }}</p>
          </div>
          <div class="txt flex-rowl">
            <p class="label">成交记录：</p>
            <p></p>
          </div>
        </div>
        <div class="item address">
          <div class="tit flex-rowl">
            <p class="label">所在地区：</p>
          </div>
          <div class="txt flex-rowl">
            <p>{{ customerDetail.other_provincename }}</p>
            <p>{{ customerDetail.other_cityname }}</p>
            <p>{{ customerDetail.other_areaname }}</p>
          </div>
          <div class="txt">
            <p>{{ customerDetail.other_address }}</p>
          </div>
        </div>
        <div class="item red">
          <div class="txt flex-rowl">
            <p class="label">当前客户归属：</p>
            <p>{{ customerDetail.info_remark }}</p>
          </div>
          <div class="txt flex-rowl">
            <p class="label">最新触达日期：</p>
            <p>{{ customerDetail.createdate | formatDate }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="main_wrap">
      <div class="record_wrap" v-if="dataList.length > 0">
        <div
          class="record_list"
          v-for="item in dataList"
          :key="item.id"
          @click="handleGo(1, item.id)"
        >
          <div class="block">
            <div class="txt red flex-rowl">
              <p class="label">添加人：</p>
              <p>{{ item.openidstr }}</p>
            </div>
            <div class="txt red flex-rowl">
              <p class="label">触达日期：</p>
              <p>{{ item.createdate | formatDate }}</p>
            </div>
            <div class="txt red flex-rowl">
              <p class="label">最近联系情况：</p>
              <p>{{ item.getstatestr }}</p>
            </div>
            <div class="txt flex-rowl">
              <p class="label">联系形式：</p>
              <p>{{ item.gettypestr }}</p>
            </div>
            <div class="txt flex-rowl">
              <p class="label">联系结果：</p>
              <p>{{ item.resultstr }}</p>
            </div>
          </div>
          <div class="remark">
            <h1>情况说明：</h1>
            <p>
              {{ item.details }}
            </p>
          </div>
          <div class="more flex-rowr">
            <div class="box flex-rowc">
              <i class="iconfont icon-gengduo"></i>
            </div>
          </div>
        </div>
      </div>
      <van-empty
        v-else-if="dataList.length == 0 && !loading"
        description="暂无数据"
      />
    </div>

    <!-- 底部操作 -->
    <div class="bottom-operation flex-between">
      <div class="arr" @click="handleReturn">
        <i class="iconfont icon-bottom"></i>
      </div>
      <div class="item_wrap">
        <div class="item_box flex-between">
          <div class="item flex-rowc" @click="handleGo(1, 0)">添加触达记录</div>
          <div class="item flex-rowc" @click="handleGo(2)">查看客户订单</div>
          <div class="item flex-rowc" @click="handleGo(5)">创建新订单</div>
        </div>
        <div class="item_box flex-between">
          <div class="item flex-rowc" @click="handleGo(4)">
            客户物流信息管理
          </div>
          <div class="item flex-rowc" @click="handleGo(3)">更新客户信息</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Clipboard from "clipboard";
import {
  getCustomerGenList,
  getCustomerDetail,
  encryptstringview,
  encryptstringadd,
} from "../../../api/api";
import { mapState } from "vuex";
export default {
  name: "rServiceDetail",
  data() {
    return {
      id: "",
      params: {
        pageindex: 1,
        pagesize: 10,
        keyword: "",
        customerid: "",
      },
      loading: false, // 是否正在加载中
      listTotal: 0,
      dataList: [],

      customerDetail: "", // 客户详情
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  mounted() {
    let { routerList } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }

    window.addEventListener("scroll", this.handleSrcoll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleSrcoll);
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.id = id;
        this.params.customerid = id;
        this.getCustomerDetail();
        this.getCustomerGenList();
      } else {
        this.$router.back();
      }
    },

    // 获取客户详情
    getCustomerDetail() {
      getCustomerDetail({ id: this.id }).then((res) => {
        this.customerDetail = res;
      });
    },
    // 获取数据
    getCustomerGenList() {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.loading = true;
      getCustomerGenList(this.params).then((res) => {
        this.dataList = [...this.dataList, ...res.list];
        this.listTotal = res.total;
        this.loading = false;
        Toast.clear();
      });
    },

    // 滚动事件
    handleSrcoll() {
      const windowHeight = window.innerHeight; // 窗口可见高度
      const documentHeight = document.documentElement.scrollHeight; // 文档高度
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop; // 滚动条距离顶部的距离

      if (
        scrollTop + windowHeight >= documentHeight &&
        !this.loading &&
        this.dataList.length < this.listTotal
      ) {
        this.params.pageindex += 1;
        this.getCustomerGenList();
      }
    },

    handleReturn() {
      this.$router.back();
    },
    handleGo(type, id) {
      if (type == 1) {
        // this.$router.push(`/resourceIndex/rServiceAddRecord/${this.id}/${id}`);
        this.encryptstringadd("rServiceAddRecord", { id: this.id, idC: id });
      } else if (type == 2) {
        // this.$router.push(`/resourceIndex/rServiceRecordList/${this.id}`);
        this.encryptstringadd("rServiceRecordList", { id: this.id });
      } else if (type == 3) {
        // this.$router.push(`/resourceIndex/updateCustomer/${this.id}/1`);
        this.encryptstringadd("updateCustomer", { id: this.id, type: 1 });
      } else if (type == 4) {
        // this.$router.push(
        //   `/resourceIndex/addressList/${this.id}/${this.customerDetail.guid}`
        // );
        this.encryptstringadd("addressList", {
          id: this.id,
          customerGuid: this.customerDetail.guid,
        });
      }else if(type == 5) {
        this.encryptstringadd("rServiceAddOrder", { id: this.id , customerGuid: this.customerDetail.guid});
      }
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },

    // 复制
    handleCopyBtn() {
      let clipboard = new Clipboard(".copy_box");
      clipboard.on("success", () => {
        // console.log("复制成功",e);
        this.$toast.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$toast.fail("复制失败");
        } else {
          this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
<style lang="less" scoped>
.detailPage {
  padding: 50px 50px 260px;
  .customer_wrap {
    font-size: 22px;
    color: #3c3c3c;
    width: 650px;
    margin: 0 auto 30px;
    margin-bottom: 30px;
    .red {
      color: #ff0036;
    }
    .customer_list {
      border: 1px solid #d2d2d2;
      padding: 40px;
      box-sizing: border-box;
      margin-bottom: 30px;
      .item {
        margin-bottom: 45px;
        .txt {
          margin-bottom: 15px;
          align-items: flex-start;
          &:last-child {
            margin-bottom: 0;
          }
          .label {
            white-space: nowrap;
            width: 160px;
            flex-shrink: 0;
          }
          .label_list {
            .label_item {
              border: 1px solid #d2d2d2;
              padding: 5px 10px 5px 20px;
              margin-right: 10px;
            }
          }
          .icon_wrap {
            a {
              color: #3c3c3c;
            }
            .icon-dianhua {
              margin-right: 40px;
            }
          }
        }
        &.address {
          .tit {
            margin-bottom: 10px;
          }
          .txt {
            font-size: 20px;
            p {
              &:nth-child(2) {
                margin: 0 30px;
              }
            }
          }
        }
        p {
          line-height: 28px;
        }
      }
    }
  }
  .main_wrap {
    .record_list {
      border: 1px solid #d2d2d2;
      padding: 40px;
      box-sizing: border-box;
      font-size: 22px;
      color: #3c3c3c;
      margin-bottom: 30px;
      .red {
        color: #ff0036;
      }
      .block {
        .txt {
          margin-bottom: 20px;
          .label {
            // width: 140px;
          }
        }
      }
      .remark {
        margin: 40px 0 35px;
        p {
          font-size: 20px;
          color: #828282;
          margin-top: 15px;
          line-height: 32px;
        }
      }
      .more {
        .box {
          width: 90px;
          height: 40px;
          border: 1px solid #aaaaaa;
          border-radius: 20px;
        }
      }
    }
  }
  .bottom-operation {
    align-items: flex-start;
    .item_wrap {
      flex-wrap: wrap;
      padding-left: 20px;
      flex: 1;
      .item_box {
        margin-bottom: 30px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>